// LocationTag.tsx
import React from 'react'
import Badge from 'react-bootstrap/Badge'

interface LocationTagProps {
  city: string // Ensure the component accepts the 'city' prop
}

const LocationTag: React.FC<LocationTagProps> = ({ city }) => {
  return (
    <Badge className="location-badge text-location-gray long-city-ellip">
      {city} {/* Render the city dynamically from the prop */}
    </Badge>
  )
}

export default LocationTag
